import React from 'react'
import matchAll from 'string.prototype.matchall'

const rule = /([#|＃][^\s]+)|(\[[^[]*]\([\d\w-]*\))/gi
const mentionRule = /(\[([^[]*)]\(([\d\w-]*)\))/gi
const mentionRuleByGroup = /\[(?<name>([^[]*))]\((?<id>([\d\w-]*))\)/gi
const hashtagRule = /([#|＃][^\s]+)/g

const useMentionsAndHashtags = () => {
  const parseMentionsAndHashtags = (text, hashtags) => {
    return parse(text, hashtags)
  }

  const parse = (value, hashtags) => {
    return value.trim().split(rule).map((splittedPart) => {
      if (splittedPart) {
        if (splittedPart.match(mentionRule)) {
          let mentionMatches = matchAll(splittedPart, mentionRuleByGroup)
          mentionMatches = Array.from(mentionMatches)
          const mentionMatch = mentionMatches[0].groups
          const name = mentionMatch.name
          return renderMention(name)
        }
        if (splittedPart.match(hashtagRule) && contentIncludesHashtag(splittedPart, hashtags)) {
          return renderHashtag(splittedPart)
        }
      }
      return splittedPart
    })
  }

  const contentIncludesHashtag = (hashtag, contentHashtags) => {
    if (!contentHashtags || typeof contentHashtags !== 'object') {
      return false
    }
    const hashtagValue =
      hashtag.charAt(0) === '#' || hashtag.charAt(0) === '＃'
        ? hashtag.substring(1)
        : hashtag
    return contentHashtags.includes(hashtagValue.toLowerCase())
  }

  const renderHashtag = (hashtag) => {
    return (
      <span style={{ fontWeight: 'bold' }}>{hashtag}</span>
    )
  }

  const renderMention = (name) => {
    return (
      <span style={{ fontWeight: 'bold' }}>{name}</span>
    )
  }

  return { parseMentionsAndHashtags }
}

export default useMentionsAndHashtags
